var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "d-flex vh-100 vw-80 flex-column justify-content-center align-items-center"
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "header header-2 mt-5" }, [
        _c("span", { staticClass: "semi-bold bigger" }, [
          _vm._v(_vm._s(_vm.$t("headers.goodbye")))
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("headers.goodbye_message")))])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex justify-content-center align-items-center" },
      [
        _c("img", {
          staticClass: "questionnaire-submited-icon",
          attrs: { src: "public/questionnaire_submited.svg", alt: "" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }